const LOGO_COLORS = [
  "#FFDFDA",
  "#D2E9FF",
  "#D6F1DA",
  "#EAE0FF",
  "#FFE9BF",
];

const firstLetter = (word: string): string => {
  for (const char of word) {
    if (/\p{L}/u.test(char)) return char.toUpperCase();
  }
  return "";
};

export const getBeneficiaryInitials = (name: string): string => {
  const words = name.trim().split(/\s+/).filter(Boolean);
  const letterWords = words.filter((w) => /\p{L}/u.test(w));

  if (letterWords.length === 0) return "";

  if (letterWords.length === 1) {
    const letters = [...letterWords[0]].filter((c) => /\p{L}/u.test(c));
    return ((letters[0] ?? "").toUpperCase() + (letters[1] ?? "").toUpperCase());
  }

  return firstLetter(letterWords[0]) + firstLetter(letterWords[1]);
};

const hexToHsl = (hex: string): [number, number, number] => {
  const n = parseInt(hex.slice(1), 16);
  const r = ((n >> 16) & 0xff) / 255, g = ((n >> 8) & 0xff) / 255, b = (n & 0xff) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b), d = max - min, l = (max + min) / 2;
  if (!d) return [0, 0, l * 100];
  const s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
  const h = max === r ? ((g - b) / d + (g < b ? 6 : 0)) / 6
    : max === g ? ((b - r) / d + 2) / 6
    : ((r - g) / d + 4) / 6;
  return [h * 360, s * 100, l * 100];
};

const hslToHex = (h: number, s: number, l: number): string => {
  const s1 = s / 100;
  const l1 = l / 100;
  const a = s1 * Math.min(l1, 1 - l1);
  const f = (n: number) => {
    const k = (n + h / 30) % 12;
    return Math.round(255 * (l1 - a * Math.max(Math.min(k - 3, 9 - k, 1), -1)))
      .toString(16).padStart(2, "0");
  };
  return `#${f(0)}${f(8)}${f(4)}`;
};

const darkenHex = (hex: string): string => {
  const [h] = hexToHsl(hex);
  return hslToHex(h, 100, 40);
};

export const getBeneficiaryLogoColor = (name: string): string => {
  const hash = [...name].reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return LOGO_COLORS[hash % LOGO_COLORS.length];
};

export const getBeneficiaryLogoTextColor = (name: string): string =>
  darkenHex(getBeneficiaryLogoColor(name));
